import React, { Component } from 'react';
import resources from '../resources';
import StoreManager from '../appdata';
import languages from '../appdata/languages';

const menuItems = [
  { key: 'home', icon: resources.images.menu_icon1, labelKey: 'homePageName' },
  { key: 'message', icon: resources.images.menu_icon2, labelKey: 'aboutPageNameMenu' },
  { key: 'ai', icon: resources.images.menu_icon3, labelKey: 'digitalTransformationPageName' },
  { key: 'target', icon: resources.images.menu_icon4, labelKey: 'businessStrategyPageName' },
  { key: 'report', icon: resources.images.menu_icon5, labelKey: 'managementReportPageName' },
];

class VerticalMenu extends Component {
  state = {
    selected: 'home',
    hoverKey: null,
    hoverIndex: null,
  };

  componentDidMount() {
    const path = window.location.pathname;

    let selected = 'home';
    if (path.startsWith('/about')) selected = 'message';
    else if (path.startsWith('/digital')) selected = 'ai';
    else if (path.startsWith('/strategy')) selected = 'target';
    else if (path.startsWith('/report')) selected = 'report';

    this.setState({ selected });
  }

  handleSelect = (key) => {
    this.setState({ selected: key, hoverKey: null });

    const appState = StoreManager.appState.thisApp;
    let path = '/';

    if (key === 'home') {
      appState.setState({ currentPage: 'HomeScreen' });
      path = '/';
    } else if (key === 'message') {
      appState.setState({ currentPage: 'AboutScreen', subPageContent: 'AboutContent' });
      path = '/about';
    } else if (key === 'ai') {
      appState.setState({ currentPage: 'DigitalTransformationScreen', subPageContent: 'DigitalTransformationContent' });
      path = '/digital';
    } else if (key === 'target') {
      appState.setState({ currentPage: 'BusinessStrategyScreen', subPageContent: 'Highlight2024Content' });
      path = '/strategy';
    } else if (key === 'report') {
      appState.setState({ currentPage: 'ManagementReportScreen', subPageContent: 'ManagementReportContent1' });
      path = '/report';
    }

    window.history.pushState({}, '', path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  render() {
    const { selected, hoverKey, hoverIndex } = this.state;
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;

    return (
      <div style={{
        position: 'fixed',
        top: '50%',
        left: 0,
        transform: 'translateY(-50%)',
        zIndex: 1000,
        padding: '16px 8px',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.9) 100%)',
        backdropFilter: 'blur(10px)',
        borderTop: '0.5px solid #FFFFFF',
        borderRight: '0.5px solid #FFFFFF',
        borderBottom: '0.5px solid #FFFFFF',
        borderTopRightRadius: 24,
        borderBottomRightRadius: 24,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 8,
      }}>
      
        {menuItems.map((item, idx) => {
          const isSelected = selected === item.key;
          const isHovered = hoverKey === item.key;
          const labelText = content[item.labelKey] || '';

          return (
            <div
              key={item.key}
              style={{ position: 'relative' }}
              onMouseEnter={() => this.setState({ hoverKey: item.key, hoverIndex: idx })}
              onMouseLeave={() => this.setState({ hoverKey: null, hoverIndex: null })}
            >
              <div
                onClick={() => this.handleSelect(item.key)}
                style={{
                  width: 36,
                  height: 36,
                  cursor: 'pointer',
                  borderRadius: 12,
                  backgroundColor: isSelected ? 'rgba(240, 90, 34, 0.2)' : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                }}
              >
                <img
                  src={item.icon}
                  alt={item.key}
                  style={{
                    width: 20,
                    height: 20,
                    opacity: isSelected ? 1 : (isHovered ? 1 : 0.6),
                    transition: 'opacity 0.2s ease',
                  }}
                />
              </div>

              {isHovered && (
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: 60,
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  borderRadius: 16,
                  padding: '6px 16px',
                  fontSize: 16,
                  fontWeight: 600,
                  color: '#E0582C',
                  whiteSpace: 'nowrap',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease',
                  maxWidth: 400,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  {labelText}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default VerticalMenu;
